import { Backtest } from "./useBacktestAPI"

const routes = [{ path: "/portpredictor-backtest", component: Backtest }]

const settings = {
  routes,
}
export default settings
